import type { FunctionComponent } from "react";

import { KeywordCompetitorsOrganicPage } from "./KeywordCompetitorsOrganicConfig";

export enum EKeywordCompetitorsPageTabs {
    Organic = 0,
}

export const KeywordCompetitorsPage: FunctionComponent = () => {
    return <KeywordCompetitorsOrganicPage />;
};
